import { IMAGES } from "@/components/shared";

const PILLARS = [
  {
    badge: "PHYSICAL",
    badgeClass: "text-[#d4af37] border-[#d4af37]/30",
    title: "Physical Infrastructure",
    blurb: "Precision low-voltage wiring, network closets, and custom hardware installations for modern properties.",
    image: IMAGES.physical,
    alt: "Smart home low-voltage theater and structured rack wiring",
    bullets: [
      "TV mounting, audio/video & home theater",
      "Smart doorbells, locks, automation & security CCTV",
      "Wi-Fi mesh, Cat6A cabling & fiber optic OTDR",
      "Server rack management & workstation builds",
    ],
    cta: "Explore Physical Services",
    testid: "physical-book-btn",
  },
  {
    badge: "DIGITAL",
    badgeClass: "text-zinc-200 border-zinc-500/30",
    title: "Digital Infrastructure",
    blurb: "High-performance web applications, AI chatbots, and streamlined automated pipelines for modern business.",
    image: IMAGES.digital,
    alt: "Modern AI automation workflow dashboard in dark mode",
    bullets: [
      "Custom website design & e-commerce systems",
      "AI chatbots & autonomous agent workflows",
      "CRM setup, integration & process automation",
      "Google Workspace & business cloud architecture",
    ],
    cta: "Explore Digital Solutions",
    testid: "digital-book-btn",
  },
];

export default function Pillars() {
  return (
    <section className="py-24 px-6 max-w-6xl mx-auto" data-testid="pillars-section">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <span className="text-xs uppercase tracking-widest text-[#d4af37] font-mono">Two Worlds • One Company</span>
        <h2 className="font-display text-3xl sm:text-4xl uppercase tracking-tight text-white mt-2">Physical Infrastructure &amp; Digital Innovation</h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {PILLARS.map((p) => (
          <div key={p.title} className="rounded-2xl p-8 bg-[#121216] gold-border flex flex-col justify-between">
            <div>
              <div className="aspect-[16/9] rounded-lg mb-6 overflow-hidden relative bg-[#0e0e12]">
                <img src={p.image} alt={p.alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20"></div>
                <span className={`absolute top-3 left-3 px-2 py-0.5 rounded bg-black/70 text-[10px] font-mono border ${p.badgeClass}`}>{p.badge}</span>
              </div>
              <h3 className="font-display text-2xl uppercase tracking-wide text-white mb-3">{p.title}</h3>
              <p className="text-xs text-zinc-400 mb-6 leading-relaxed">{p.blurb}</p>
              <ul className="space-y-2.5 text-xs text-zinc-300 font-mono">
                {p.bullets.map((b) => (
                  <li key={b} className="flex items-center gap-2"><span className="text-[#d4af37]">▶</span> {b}</li>
                ))}
              </ul>
            </div>
            <a
              href="/services"
              data-testid={p.testid}
              className="mt-8 block text-center py-2.5 rounded border border-[#d4af37]/30 text-xs font-mono uppercase tracking-wider text-[#d4af37] hover:bg-[#d4af37] hover:text-black transition-colors"
            >
              {p.cta}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
